import { svgAnimatedBackground as consumption } from '../../public/themes/consumption/bg';
import { svgAnimatedBackground as consumptionOld } from '../../public/themes/consumption-old/bg';
import { svgAnimatedBackground as fabric } from '../../public/themes/fabric/bg';
import { svgAnimatedBackground as heat } from '../../public/themes/heat/bg';
import { svgAnimatedBackground as heatOld } from '../../public/themes/heat-old/bg';
import { svgAnimatedBackground as multi } from '../../public/themes/multi/bg';
import { svgAnimatedBackground as water } from '../../public/themes/water/bg';
import { svgAnimatedBackground as resourceSupply } from '../../public/themes/resource-supply/bg';

export const themeBg: { [key: string]: string } = {
    "consumption": consumption,
    "consumption-old": consumptionOld,
    "fabric": fabric,
    "heat": heat,
    "heat-old": heatOld,
    "multi": multi,
    "water": water,
    "resource-supply": resourceSupply,
}
